import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { SpecraButton, SpecraFormField, SpecraSelect } from '@mono/ui-components';
import { Testids } from '@mono/ui-selectors';
import { useMutation } from '@tanstack/react-query';
import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../../../contexts/authContext';
import { contractsClient } from '../../Delivery/Registries/Contracts/api';
export function AwardFollowOn({ contractId, label, keys }) {
    const { user } = useAuth();
    const navigate = useNavigate();
    const [current, setCurrent] = useState('');
    const [ultimate, setUltimate] = useState('');
    const open = useMutation({
        mutationFn: async ()=>{
            if (!user?.tenant_id || !user.id) throw new Error('Sign in required');
            // Persist the deliberate request across remounts, retries and navigation.
            // Reading the Registry never invokes the creation RPC.
            const key = `award-follow-on:${user.tenant_id}:${user.id}:${contractId}`;
            let request = sessionStorage.getItem(key);
            if (!request) {
                request = crypto.randomUUID();
                sessionStorage.setItem(key, request);
            }
            return contractsClient.openAwardFollowOn({
                contractId,
                openingRequestId: request,
                title: `Follow-on: ${label}`,
                current: current ? JSON.parse(current) : undefined,
                ultimate: ultimate ? JSON.parse(ultimate) : undefined
            });
        },
        onSuccess: ({ signal })=>{
            if (signal) navigate(`/opportunities?watchOpportunity=${encodeURIComponent(signal.opportunityId)}`);
        }
    });
    const select = (measure, value, set)=>/*#__PURE__*/ _jsx(SpecraFormField, {
            label: measure === 3 ? 'Current completion evidence' : 'Ultimate completion evidence',
            htmlFor: `award-evidence-${measure}`,
            children: /*#__PURE__*/ _jsxs(SpecraSelect, {
                id: `award-evidence-${measure}`,
                value: value,
                onChange: (e)=>set(e.target.value),
                "data-testid": measure === 3 ? Testids.awardSignal.current : Testids.awardSignal.ultimate,
                children: [
                    /*#__PURE__*/ _jsx("option", {
                        value: "",
                        children: "Unknown / not selected"
                    }),
                    [
                        ...new Set(keys.filter((k)=>k.measure === measure).map(({ scope, period })=>JSON.stringify({
                                scope,
                                period
                            })))
                    ].map((key)=>{
                        const selected = JSON.parse(key);
                        return /*#__PURE__*/ _jsxs("option", {
                            value: key,
                            children: [
                                selected.scope,
                                " · ",
                                selected.period
                            ]
                        }, key);
                    })
                ]
            })
        });
    return /*#__PURE__*/ _jsxs("div", {
        className: "space-y-2",
        children: [
            /*#__PURE__*/ _jsx("p", {
                children: "Historical award — research context, not an open bid target. Incomplete evidence can still seed a deliberate follow-on."
            }),
            select(3, current, setCurrent),
            select(4, ultimate, setUltimate),
            /*#__PURE__*/ _jsx(SpecraButton, {
                "data-testid": Testids.awardSignal.create,
                disabled: open.isPending,
                onClick: ()=>open.mutate(),
                children: open.isPending ? 'Opening follow-on…' : 'Create follow-on Opportunity'
            }),
            open.error && /*#__PURE__*/ _jsx("p", {
                role: "alert",
                children: "Could not open follow-on. Check your access and retry; the same request is retained."
            })
        ]
    });
}
